import { render, staticRenderFns } from "./station_anchorSaddle.vue?vue&type=template&id=0f899688&scoped=true"
import script from "./station_anchorSaddle.vue?vue&type=script&lang=js"
export * from "./station_anchorSaddle.vue?vue&type=script&lang=js"
import style0 from "./station_anchorSaddle.vue?vue&type=style&index=0&id=0f899688&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f899688",
  null
  
)

export default component.exports